<script>
import qs from "qs";

export default {
  computed: {
  },
  props: {
    formData: Object,
    disabled: Boolean,
    detail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 国家下拉
      countryOpList: [{vcName: '中国', vcCode: 'AREA-101'}],
      //地区
      areaInfo: [],
      //省
      provinces: [],
      //市
      cities: [],
      // 区
      areas: [],
      rules: {
        province: {
          required: true,
          message: this.$t("demandMgt.pleaseEnter"),
          trigger: "change"
        },
        city: {
          required: true,
          message: this.$t("demandMgt.pleaseEnter"),
          trigger: "change",
          validator: (rule, value, callback) => {
            if (this.cities.length === 0) {
              callback();
            } else {
              if (!value) {
                callback(new Error(this.$t("demandMgt.pleaseEnter")));
              } else {
                callback();
              }
            }
          }
        },
        area: {
          required: true,
          message: this.$t("demandMgt.pleaseEnter"),
          trigger: "change",
          validator: (rule, value, callback) => {
            if (this.areas.length === 0) {
              callback();
            } else {
              if (!value) {
                callback(new Error(this.$t("demandMgt.pleaseEnter")));
              } else {
                callback();
              }
            }
          }
        },
      }
    }
  },
  methods: {
    // 获取国家列表
    getCountryOptions() {
      const url = "/api/basicInformation/getCountryOptions";
      this.$http
        .post(url)
        .then(response => {
          this.countryOpList = response.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    selectRegionString(){
      let arr =[this.formData.country,this.formData.province,this.formData.city,this.formData.area];
      return arr
        .map((item,index) => {
          const foundItem = this.areaInfo.find(area => area.vcCode === item);
            let suffix = '';
            if (arr.length === 3) {
              if (index === 0) {
                suffix = '省';
              } else if (index === 1) {
                suffix = '市';
              } else if (index === 2) {
                suffix = '区';
              }
            } else if (arr.length === 2) {
              if (index === 0) {
                suffix = '市';
              } else if (index === 1) {
                suffix = '区';
              }
            }
          return foundItem ? foundItem.vcName + suffix : ''; // 如果找到了对应的项，则返回其 codeValue，否则返回空字符串
        })
        .join('');
    },
    // 根据名称查国家编号
    selectCountryCodeByName(locate) {
      let countryList = this.countryOpList.filter(item => {
        return item.vcCode === locate;
      });
      if (countryList.length > 0) {
        return countryList[0].vcCode;
      } else {
        return null;
      }
    },
    // 省市区Code获取
    haddleRegionCode() {
      if (this.formData.province) {
        this.formData.provinceCode = this.selectProvincesCodeByName(this.formData.province)
      } else {
        this.formData.provinceCode = ""
      }
      if (this.formData.city) {
        this.formData.cityCode = this.selectAreasCodeByName(this.formData.city)
      } else {
        this.formData.cityCode = ""
      }
      if (this.formData.area) {
        this.formData.areaCode = this.selectAreaCodeByName(this.formData.area)
      } else {
        this.formData.areaCode = ""
      }
      return this.formData
    },
    // 根据名称查地域编号
    selectProvincesCodeByName(locate) {
      let provList = this.provinces.filter(item => {
        return item.vcCode === locate;
      });
      if (provList.length > 0) {
        return provList[0].vcCode;
      } else {
        return null;
      }
    },
    // 根据名称查地域编号
    selectAreasCodeByName(locate) {
      let provList = this.cities.filter(item => {
        return item.vcCode === locate;
      });

      if (provList.length > 0) {

        return provList[0].vcCode;
      } else {
        return null;
      }
    },
    // 查地区编号
    selectAreaCodeByName(locate) {
      return this.areas.filter(item => {
        return item.vcCode === locate;
      })[0].vcCode;
    },
    // 手动输入省份，前缀过滤选择列表
    querySearchProvince(queryString, callback) {
      var provinces = this.provinces;
      var results = queryString
        ? provinces.filter(province => {
          return (
            province.vcName
              .toLowerCase()
              .indexOf(queryString.toLowerCase()) === 0
          );
        })
        : provinces;

      callback(
        results.map(item => {
          return {value: item.vcName};
        })
      );
    },
    // 手动输入国家改变事件
    async countryChange(country) {
      // 清除区域
      this.$refs.provinceRef.resetField()
      this.$refs.cityRef.resetField()
      this.$refs.areaRef.resetField()
      this.provinces = []
      this.cities = []
      this.areas = []
      // 判断是否存在该国家
      if (this.selectCountryCodeByName(country)) {
        // 加载省份列表
        await this.handleSelectCountry({value: country});
      } else {
        this.provinces = [];
      }
    },
    // 手动输入省份改变事件
    provinceChange(province) {
      // 清除区域
      this.$refs.cityRef.resetField()
      this.$refs.areaRef.resetField()
      this.cities = []
      this.areas = []
      // 判断是否存在该省份
      if (this.selectProvincesCodeByName(province)) {
        // 加载城市列表
        this.handleSelectProvince({value: province});
      } else {
        this.cities = [];
      }
    },
    // 城市改变清除区域
    cityChange(city) {
      // 清除区域
      this.$refs.areaRef.resetField()
      this.areas = []
      // 判断是否存在该区
      if (this.selectAreasCodeByName(city)) {
        // 加载区
        this.handleSelectCity({value: city});
      } else {
        this.areas = [];
      }
    },
    // 选择国家时加载省份
    async handleSelectCountry(country) {
      let countryCode = this.selectCountryCodeByName(country.value);
      await this.getChineArea();
      this.getProvinceData(countryCode);
    },
    // 选择省份时加载市
    handleSelectProvince(province) {
      let proCode = this.selectProvincesCodeByName(province.value);
      this.getCityOrRegionData(proCode);
    },
    // 选择市时加载区
    handleSelectCity(city) {
      let proCode = this.selectAreasCodeByName(city.value);
      this.getAreasData(proCode);
    },
    // 清除国家时清除省、市、区域
    clearCountry() {
      this.$refs.provinceRef.resetField()
      this.$refs.cityRef.resetField()
      this.$refs.areaRef.resetField()
      this.provinces = []
      this.cities = []
      this.areas = []
    },
    // 清除省份时清除市、区域
    clearProvince() {
      this.$refs.provinceRef.resetField()
      this.$refs.cityRef.resetField()
      this.$refs.areaRef.resetField()
      this.cities = []
      this.areas = []
    },
    // 清除市时清除区域
    clearCity() {
      this.$refs.cityRef.resetField()
      this.$refs.areaRef.resetField()
      this.provinceChange(this.formData.province);
    },
    // 清除区域
    clearArea() {
      this.$refs.areaRef.resetField()
    },
    // 获取所属城市
    async getChineArea() {
      let url = "/api/basicInformation/getAreaInfoByCountry";
      let params = {vcCode: this.formData.country};
      await this.$http
        .post(url, qs.stringify(params))
        .then(response => {
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            // 所有地区信息
            this.areaInfo = response.data.data;
            // 省
            for (let i = 0; i < this.areaInfo.length; i++) {
              if (this.areaInfo[i].vcCode.length === 10) {
                this.provinces.push(this.areaInfo[i]);
              }
            }
            this.$nextTick(() => {
              // 市 判断是否存在该省份
              if (
                this.selectProvincesCodeByName(
                  this.formData.province
                )
              ) {
                // 加载市
                let proCode = this.selectProvincesCodeByName(
                  this.formData.province
                );
                for (let i = 0; i < this.areaInfo.length; i++) {
                  if (
                    proCode === this.areaInfo[i].vcCode.substring(0, 10) &&
                    this.areaInfo[i].vcCode.length === 12
                  ) {
                    this.cities.push(this.areaInfo[i]);
                  }
                }
              } else {
                this.cities = [];
              }
              // 区 判断是否存在该区
              if (
                this.selectAreasCodeByName(
                  this.formData.city
                )
              ) {
                // 加载区
                let proCodeArea = this.selectAreasCodeByName(
                  this.formData.city
                );
                for (let i = 0; i < this.areaInfo.length; i++) {
                  if (
                    proCodeArea === this.areaInfo[i].vcCode.substring(0, 12) &&
                    this.areaInfo[i].vcCode.length === 14
                  ) {
                    this.areas.push(this.areaInfo[i]);
                  }
                }
              } else {
                this.areas = [];
              }
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 加载省
    getProvinceData(val) {
      this.provinces = [];
      for (let i = 0; i < this.areaInfo.length; i++) {
        if (
          val === this.areaInfo[i].vcCode.substring(0, 8) &&
          this.areaInfo[i].vcCode.length === 10
        ) {
          this.provinces.push(this.areaInfo[i]);
        }
      }
    },
    // 加载市
    getCityOrRegionData(val) {
      this.cities = [];
      for (let i = 0; i < this.areaInfo.length; i++) {
        if (
          val === this.areaInfo[i].vcCode.substring(0, 10) &&
          this.areaInfo[i].vcCode.length === 12
        ) {
          this.cities.push(this.areaInfo[i]);
        }
      }
    },
    // 加载区
    getAreasData(val) {
      this.areas = [];
      for (let i = 0; i < this.areaInfo.length; i++) {
        if (
          val === this.areaInfo[i].vcCode.substring(0, 12) &&
          this.areaInfo[i].vcCode.length === 14
        ) {
          this.areas.push(this.areaInfo[i]);
        }
      }
    },
  },
  mounted() {
    this.getCountryOptions();
  },
  created() {
  }
}
</script>

<template>
  <div>
    <span v-if="detail">{{ selectRegionString() }}</span>
    <el-form v-if="!detail" ref="formDataRef" :model="formData">
      <el-col style="width: 20%;">
        <!-- 国家 -->
        <el-form-item prop="country">
          <el-select
            v-model="formData.country"
            :disabled="disabled"
            :placeholder="$t('common.pleaseSelect')"
	          clearable
            filterable
            size="small"
	          @change="countryChange"
            @clear="clearCountry"
            @select="handleSelectCountry"
          >
            <el-option
              v-for="item in countryOpList"
              :key="item.vcCode"
              :label="item.vcName"
              :value="item.vcCode"
              style="width: 100%;"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col style="width: 24%;">
        <!-- 省 -->
        <el-form-item ref="provinceRef" label-width="10px" prop="province">
          <el-select
            v-model="formData.province"
            :disabled="!formData.country||disabled"
            :placeholder="$t('p0204.province')"
            clearable
            filterable
            size="small"
            style="width: 100%"
            @change="provinceChange"
            @clear="clearProvince"
            @select="handleSelectProvince"
          >
            <el-option
              v-for="province in provinces"
              :key="province.vcCode"
              :label="province.vcName"
              :value="province.vcCode"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col style="width: 28%;">
        <!-- 市 -->
        <el-form-item ref="cityRef" label-width="10px" prop="city">
          <el-select
            v-model="formData.city"
            :disabled="!formData.province||disabled"
            :placeholder="$t('p0204.city')"
            clearable
            filterable
            size="small"
            style="width: 100%"
            @change="cityChange"
            @clear="clearCity"
            @select="handleSelectCity"
          >
            <el-option
              v-for="city in cities"
              :key="city.vcCode"
              :label="city.vcName"
              :value="city.vcCode"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col style="width: 28%;">
        <!-- 区 -->
        <el-form-item ref="areaRef" label-width="10px" prop="area">
          <el-select
            v-model="formData.area"
            :disabled="!formData.city||disabled"
            :placeholder="$t('p0204.area')"
            clearable
            filterable
            size="small"
            style="width: 100%"
            @clear="clearArea"
          >
            <el-option
              v-for="area in areas"
              :key="area.vcCode"
              :label="area.vcName"
              :value="area.vcCode"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-form>
  </div>
</template>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/ResourceBaseManagement/ResourceUser/RegionQuery.vue